import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import businessData from '../assets/data/business.json';
import './RadarChart.css';

const RadarChart = () => {
  const chartRef = useRef(null);

  useEffect(() => {
    // 从业务数据中提取雷达图指标
    const { radarMetrics } = businessData;
    
    // 初始化图表实例
    const chartInstance = echarts.init(chartRef.current);

    // 配置项
    const option = {
      title: {
        text: '福州市局六维能力模型',
        textStyle: {
          color: '#ffffff',
          fontSize: 14,
          fontWeight: 'normal'
        },
        left: 'center'
      },
      tooltip: {},
      legend: {
        data: ['福州市局', '平均值'],
        bottom: 0,
        textStyle: { color: '#ffffff' }
      },
      radar: {
        name: {
          textStyle: {
            color: '#3b82f6',
            backgroundColor: 'transparent',
            borderRadius: 3,
            padding: [3, 5]
          }
        },
        indicator: radarMetrics.map(item => ({ name: item.metric, max: 100 })),
        splitArea: {
          areaStyle: {
            color: ['rgba(30, 58, 138, 0.2)', 'rgba(30, 58, 138, 0.1)']
          }
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(59, 130, 246, 0.3)'
          }
        }
      },
      series: [{
        name: '绩效对比',
        type: 'radar',
        data: [
          {
            value: radarMetrics.map(item => item.actual),
            name: '福州市局',
            areaStyle: { opacity: 0.4 },
            itemStyle: { color: '#3b82f6' }, // 蓝色
            lineStyle: { color: '#3b82f6', width: 2 }
          },
          {
            value: radarMetrics.map(item => item.target),
            name: '平均值',
            areaStyle: { opacity: 0.2 },
            itemStyle: { color: '#f59e0b' }, // 金色
            lineStyle: { color: '#f59e0b', width: 2 }
          }
        ]
      }]
    };

    // 设置配置项
    chartInstance.setOption(option);

    // 响应窗口大小变化
    const handleResize = () => {
      chartInstance.resize();
    };
    
    window.addEventListener('resize', handleResize);

    // 清理函数
    return () => {
      window.removeEventListener('resize', handleResize);
      chartInstance.dispose();
    };
  }, []);

  return <div ref={chartRef} className="radar-chart"></div>;
};

export default RadarChart;